import { Controller } from '@hotwired/stimulus'

// Dropdown controller for custom dropdowns
// Usage: <div data-controller="dropdown">
//          <button data-action="dropdown#toggle">Menu</button>
//          <div data-dropdown-target="menu" class="hidden">...</div>
//        </div>
export default class extends Controller {
  static targets = ['menu']

  connect () {
    this.isOpen = false
    // Close dropdown when clicking outside
    this.clickOutsideHandler = this.clickOutside.bind(this)
    document.addEventListener('click', this.clickOutsideHandler)
  }

  disconnect () {
    document.removeEventListener('click', this.clickOutsideHandler)
  }

  toggle (event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open () {
    this.menuTarget.classList.remove('hidden')
    this.menuTarget.classList.add('show')
    this.isOpen = true
  }

  close () {
    this.menuTarget.classList.add('hidden')
    this.menuTarget.classList.remove('show')
    this.isOpen = false
  }

  clickOutside (event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.close()
    }
  }
}
